var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colors } from '../styleConstants';
export var StyledBall = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n\n  background: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n\n  background: ", ";\n"])), function (p) { return p.size; }, function (p) { return p.size; }, function (p) {
    switch (p.variant) {
        case 'on': {
            return p.theme.colors.buttons.primary;
        }
        case 'off': {
            return colors.primaryGreyMediumDark;
        }
        case 'disabled': {
            return colors.primaryGreyMediumLight;
        }
        default: {
            return p.theme.colors.buttons.primary;
        }
    }
});
var templateObject_1;
